export default "__VITE_ASSET__D08fWv9e__"